import { render, staticRenderFns } from "./ExciseStratum.vue?vue&type=template&id=670338a2&"
import script from "./ExciseStratum.vue?vue&type=script&lang=js&"
export * from "./ExciseStratum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports